import { useTranslation } from 'react-i18next'

import { faDigits } from '../../lib/numerals'
import { activityKind, activityRows, activityState } from '../../lib/teams'
import { MemberDisc } from './TeamCard'
import UserLink from './UserLink'

/**
 * The teammates' day on home (V5-w), from `teams_activity`: «زهرا در حال
 * تمرین است», «علی امروز ۲۵ امتیاز گرفت». Renders nothing unless teams are
 * switched on and the learner has teammates — the server answers
 * `enabled: false` with no items until `teams.enabled` is turned on, so
 * home looks exactly as it did. A row opens that teammate's public profile.
 * Only what the contract lets a teammate see: the member's feed fields,
 * the day's XP, and a practising-now boolean (never a time).
 */
export default function TeamActivity({ answer }) {
  const { t } = useTranslation('teams')
  if (activityState(answer) === 'hidden') return null
  const { shown, more } = activityRows(answer.items)

  return (
    <section className="space-y-2.5 card-soft p-3.5" data-team-activity={answer.items.length}>
      <h2 className="text-[13.5px] font-bold text-ink">{t('activity.heading')}</h2>
      <ul className="space-y-1.5" aria-label={t('activity.ariaList')}>
        {shown.map((item) => {
          const { member } = item
          const kind = activityKind(item)
          const name = member.me ? t('activity.you') : member.displayName
          return (
            <li key={member.id}>
              <UserLink userId={member.id} className="flex items-center gap-3 rounded-xl px-1.5 py-1.5 transition hover:bg-surface-2">
                <MemberDisc avatar={member.avatar} photoUrl={member.photoUrl} size={34} />
                <span className="min-w-0 flex-1 text-[12.5px] leading-[1.8] text-ink-2" data-activity={kind}>
                  {kind === 'practicing'
                    ? t('activity.practicing', { name })
                    : kind === 'xp'
                      ? t('activity.xp', { name, xp: faDigits(item.xpToday) })
                      : t('activity.idle', { name })}
                </span>
                {kind === 'practicing' && (
                  <span className="flex shrink-0 items-center gap-1 rounded-full bg-good-tint px-2 py-0.5 text-[10.5px] font-bold text-good-ink">
                    <span className="size-1.5 rounded-full bg-good" aria-hidden="true" />
                    {t('activity.now')}
                  </span>
                )}
              </UserLink>
            </li>
          )
        })}
      </ul>
      {more > 0 && <p className="text-[11.5px] text-ink-3">{t('activity.more', { n: faDigits(more) })}</p>}
    </section>
  )
}
